import React from "react"
import TextInput from "./TextInput"

export default class NameInput extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="NameInput">
				<div className="row">
					<div className="col-sm-6">
						<TextInput name="first_name" placeholder="First Name" onChange={this.onChange} icon={<span className="fa fa-user"></span>} />
					</div>
					<div className="col-sm-6">
						<TextInput name="last_name" placeholder="Last Name" onChange={this.onChange} icon={<span className="fa fa-user"></span>} />
					</div>
				</div>
			</div>
		);	
	}

}